import React from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export interface CreateTenantActionWarningsProps {
  pmaWarningKind: 'rejected' | 'pending' | null
  recordHasFormatWarnings: boolean
  /** When true, PMA/TESA warnings are hidden (NGOM/VNEM and National accounts are agreement-exempt). */
  isAgreementExempt?: boolean
}

const CreateTenantActionWarnings: React.FC<CreateTenantActionWarningsProps> = ({
  pmaWarningKind,
  recordHasFormatWarnings,
  isAgreementExempt = false,
}) => {
  const showPmaWarning = pmaWarningKind != null && !isAgreementExempt

  if (!showPmaWarning && !recordHasFormatWarnings) {
    return null
  }

  return (
    <div className="space-y-3">
      {showPmaWarning ? (
        <div className="flex items-start gap-3 rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/30 p-3">
          <ExclamationTriangleIcon className="w-5 h-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
          <div className="text-sm text-amber-900 dark:text-amber-100">
            <p className="font-medium">No accepted PMA on file</p>
            <p className="mt-1">
              The latest utility authorization{' '}
              {pmaWarningKind === 'rejected' ? 'was rejected by the utility' : 'is still awaiting a utility response'} and no
              external PMA has been uploaded.
            </p>
          </div>
        </div>
      ) : null}
      {recordHasFormatWarnings ? (
        <div className="flex items-start gap-3 rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/30 p-3">
          <ExclamationTriangleIcon className="w-5 h-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
          <div className="text-sm text-amber-900 dark:text-amber-100">
            <p className="font-medium">Validation warnings present</p>
            <p className="mt-1">
              Some fields on this record don't match the expected format. Please review the amber warnings on the utility
              account tabs before proceeding.
            </p>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default CreateTenantActionWarnings
